// Shared 402 / failure rendering for every mode panel. Two distinct 402
// shapes come out of the mock (and will out of the real backend, per
// OBT_INTEGRATION_SPEC.md §4): insufficient CPU/GPU compute credit, and
// "this seat has no GPU tier" (gpu_tier_required) — the upgrade path.
export default function ErrorNote({ error }) {
  if (!error) return null;

  if (error.status === 402) {
    if (error.detail?.reason === 'gpu_tier_required') {
      return (
        <p className="aq-note aq-note--error">
          GPU tier required — this seat is CPU-only.{' '}
          <strong>Upgrade to a GPU-enabled seat</strong> to run this on GPU.
        </p>
      );
    }
    return (
      <p className="aq-note aq-note--error">
        Insufficient compute credit — balance ${error.detail?.balanceUsd?.toFixed?.(2) ?? '?'}, need $
        {error.detail?.requiredUsd?.toFixed?.(2) ?? '?'}.
      </p>
    );
  }

  return <p className="aq-note aq-note--error">Run failed: {error.message}</p>;
}
